import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=e8154654&scoped=true&"
import script from "./index copy 2.vue?vue&type=script&lang=js&"
export * from "./index copy 2.vue?vue&type=script&lang=js&"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=e8154654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8154654",
  null
  
)

export default component.exports